import { Auth0ClientOptions } from '@auth0/auth0-spa-js';
import { checkEnvVariables } from './checkEnvVariables';
import { checkPathAndStoreOrigin } from './checkPathAndStoreOrigin';
import { getRedirectURI } from './getRedirectURI';

declare global {
  interface Window {
    Cypress: any;
  }
}

checkPathAndStoreOrigin();
checkEnvVariables();

export const config: Auth0ClientOptions = {
  domain: process.env.REACT_APP_AUTH_DOMAIN!,
  clientId: process.env.REACT_APP_AUTH_CLIENT_ID!,
  cacheLocation: 'memory',
  useRefreshTokens: true,
  useRefreshTokensFallback: true, // allows iframe-based token recovery
  authorizationParams: {
    audience: process.env.REACT_APP_API_AUTH_AUDIENCE!,
    redirect_uri: getRedirectURI(),
  },
};
